import { PUBLIC_LABEL, RESTRICTED_LABEL } from './constants';

export const getFolderStatus = async (currentDir, filePath, currentFile) => {
  if (!currentDir || !filePath.length) return false;

  let isShared = [];

  if (
    currentDir === currentFile?.metadata?.FileUuid &&
    (currentFile?.shared?.restricted?.length || currentFile?.shared?.public?.length)
  ) {
    isShared = [currentFile];
  } else {
    isShared = filePath.filter(({ metadata, shared }) => {
      return (
        (shared?.public && shared?.public?.length > 0) ||
        (shared?.restricted && shared?.restricted?.length > 0)
      );
    });
  }

  if (!isShared?.length) return false;
  if (isShared[0]?.shared?.public && isShared[0]?.shared?.public?.length > 0) {
    return PUBLIC_LABEL;
  }
  if (isShared[0]?.shared?.restricted && isShared[0]?.shared?.restricted?.length > 0) {
    return RESTRICTED_LABEL;
  }
  return false;
};
